<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Просмотр статистики для пользователей</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-layout>
                    <v-flex xs5>
                        <sex :data-sex="customer"/>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5>
                        <device :data-device="customer"/>
                    </v-flex>
                </v-layout>
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0">Другое</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Текущее кол-во бонусов у пользователей:</v-subheader>
                            <b>{{ customer.bonus | formatPrice }} баллов</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'
    import Sex from './Components/Customer/Sex'
    import Device from './Components/Customer/Device'

    export default {
        name: 'statisticCustomerTelegram',
        components: {
            Loader,
            Sex,
            Device
        },
        data: () => ({
            loading: false,
            customer: {
                all: 0,
                active: 0,
                not_active: 0,
                man: 0,
                woman: 0,
                bonus: 0,
                all_devices: 0,
                ios: 0,
                android: 0
            }
        }),
        mounted () {
            this.loading = true

            Statistic
                .getCustomerStat()
                .then(response => this.customer = response.data.data)
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
        created () {
            this.setHeaderTitle('Клиенты')
        },
        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            }
        }
    }
</script>
